import { createContext, useContext, useReducer, useEffect, useRef } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

const initialState = { user: null, loading: true };

function authReducer(state, action) {
  switch (action.type) {
    case 'SET_USER':
      return { user: action.payload, loading: false };
    case 'LOGOUT':
      return { user: null, loading: false };
    case 'LOADED':
      return { ...state, loading: false };
    default:
      return state;
  }
}

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const checkedRef = useRef(false);

  useEffect(() => {
    // Only check once, even in StrictMode
    if (checkedRef.current) return;
    checkedRef.current = true;

    api.get('/auth/me/')
      .then((res) => dispatch({ type: 'SET_USER', payload: res.data }))
      .catch(() => dispatch({ type: 'LOADED' }));
  }, []);

  const login = async (email, password) => {
    console.log('[AUTH] login called, posting to /auth/login/');
    const res = await api.post('/auth/login/', { email, password });
    console.log('[AUTH] login response:', res.status, res.data);
    dispatch({ type: 'SET_USER', payload: res.data });
    return res.data;
  };

  const register = async (email, username, password, name) => {
    const res = await api.post('/auth/register/', { email, username, password, name });
    dispatch({ type: 'SET_USER', payload: res.data });
    return res.data;
  };

  const logout = async () => {
    await api.post('/auth/logout/');
    dispatch({ type: 'LOGOUT' });
  };

  const googleLogin = async (credential) => {
    const res = await api.post('/auth/google/', { credential });
    dispatch({ type: 'SET_USER', payload: res.data });
    return res.data;
  };

  const updateUser = async (data) => {
    const res = await api.patch('/auth/me/', data);
    dispatch({ type: 'SET_USER', payload: res.data });
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ ...state, login, register, googleLogin, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
